module.exports = __webpack_public_path__ + "img/3.f7fcf8be.png";